import { Stack, Typography } from '@mui/material'
import * as sxStyles from '../AnalyticsDetails.styled'
import Grid from '@mui/material/Grid2'
import { CardWithTitle } from './CardWithTitle'
import ErrorIcon from '@mui/icons-material/Error'

export const DeliveryErrorState = () => {
  return (
    <Stack sx={sxStyles.mainGrid}>
      <Grid size={12}>
        <CardWithTitle title="Analysis Results" />
      </Grid>
      <Stack
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          width: '100%',
        }}
      >
        <Stack
          sx={{
            alignItems: 'center',
            flexDirection: 'row',
            gap: 1,
          }}
        >
          <ErrorIcon color="error" />
          <Typography color="error">Error loading analysis data </Typography>
        </Stack>
      </Stack>
    </Stack>
  )
}
